import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  data: [],
  total: 0,
};

const myListZiadost = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_MY_LIST_ZIADOST_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_MY_LIST_ZIADOST_SUCCESS:
      const { Items, TotalRecords } = action.res.Data;
      return { ...state, isLoading: false, data: Items, total: TotalRecords };

    case actionTypes.GET_MY_LIST_ZIADOST_FAILURE:
      return _initState;

    default:
      return state;
  }
};

export default myListZiadost;
